// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"style_formTitle__OkosI","formInfo":"style_formInfo__3vfam","main-body":"style_main-body__1X654","wapper":"style_wapper__1xLdX"};